import {Text} from "@gs-ux-uitoolkit-react/text";
import {FormControl} from "@gs-ux-uitoolkit-react/form";
import clsx from "clsx";
import {SelectComboInput} from "./SelectComboInput";
import React, {memo} from "react";
import {InputStatus} from "@gs-ux-uitoolkit-react/input";

type Props = {
    id?: string;
    name: string;
    options: { label: string; value: string; disabled?: boolean }[];
    label?: string;
    value?: string;
    className?: string;
    disabled?: boolean;
    helperText?: string;
    onErrorHighlightBorderOnly?: boolean;
    placeholder?: string;
    error?: string;
    onSelect?: (newSelected: { label: string; value: string }) => void;
    readOnly?: boolean;
    isRequired?: boolean;
    setValue: (newVal: string) => void;
    validateField?: (newVal: string) => void;
    clearable?: boolean;
    onBlur?: (e: React.FocusEvent<any>) => void;
    status?: InputStatus;
    allowCustomValue?: boolean;
};

export const FormSelectInput = memo(function ({
                                                  id,
                                                  label,
                                                  helperText,
                                                  options,
                                                  disabled,
                                                  className,
                                                  placeholder,
                                                  onSelect,
                                                  readOnly,
                                                  isRequired,
                                                  error,
                                                  onErrorHighlightBorderOnly,
                                                  value,
                                                  setValue,
                                                  validateField,
                                                  name,
                                                  onBlur,
                                                  status,
                                                  allowCustomValue
                                              }: Props) {
    return (
        <FormControl id={id} className={clsx(className, "relative")}>
            {label ? (
                <Text typography="textBody02Medium" className="mb-1" color="colorTextNeutralBold">
                    <label htmlFor={name}>
                        {label}
                    </label>
                    {isRequired && <span className="text-gray-90 ml-1">*</span>}
                </Text>
            ) : null}
            {readOnly ? (
                <Text>{options.find((it) => it.value === value)?.label}</Text>
            ) : (
                <SelectComboInput
                    name={name}
                    status={error ? "error" : status}
                    onChange={async (newSelected) => {
                        if (onSelect)
                            onSelect(newSelected);
                        setValue(newSelected?.value)
                        if (validateField)
                            validateField(newSelected?.value)
                    }}
                    selectedValue={value}
                    disabled={disabled}
                    options={options}
                    placeholder={placeholder}
                    onBlur={onBlur}
                    allowCustomValue={allowCustomValue}
                />
            )}
            {
                helperText && !error &&
                <Text typography="textCaption01Regular" color="colorTextNeutralBold">{helperText}</Text>
            }
            {
                error && !onErrorHighlightBorderOnly &&
                <Text typography="textCaption01Regular" color="red060">{error}</Text>
            }
        </FormControl>
    );
}, (prevProps, nextProps) => {
    return prevProps.value === nextProps.value &&
        prevProps.error === nextProps.error &&
        prevProps.name === nextProps.name &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.validateField === nextProps.validateField &&
        prevProps.setValue === nextProps.setValue &&
        prevProps.isRequired === nextProps.isRequired &&
        prevProps.label === nextProps.label
})